// extracted by mini-css-extract-plugin
module.exports = {"root":"FacebookAdMessage_root__q7ydp","message":"FacebookAdMessage_message__3jVHk","source":"FacebookAdMessage_source__3fWtm"};